import { Button, Tooltip } from 'antd';
import React, { ReactNode, useCallback, useRef, useState } from 'react';
import styles from './style.module.scss';

interface IProps {
    icon: ReactNode
    onClick(): void
}

const AddTaskButton: React.FC<IProps> = ({ icon, onClick }) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const suppressTooltip = useRef(false);

    const handleClick = useCallback(() => {
        suppressTooltip.current = true;
        setIsTooltipOpen(false);
        onClick();
    }, [onClick])

    const handleMouseLeave = useCallback(() => {
        suppressTooltip.current = false;
        setIsTooltipOpen(false);
    }, [])

    return <Tooltip
        title='Add task'
        placement='top'
        arrow={{ pointAtCenter: true }}
        classNames={{ root: styles.tooltip }}
        mouseEnterDelay={0.8}
        open={isTooltipOpen}
        onOpenChange={(open) => {
            if (!open || !suppressTooltip.current)
                setIsTooltipOpen(open)
        }}
    >
        <Button
            type='text'
            shape='circle'
            size='small'
            aria-label='Add task'
            className={`bt-add ${styles.button}`}
            icon={icon}
            onClick={handleClick}
            onMouseLeave={handleMouseLeave}
        />
    </Tooltip>
}

export default AddTaskButton;
